import { useAuth0 } from "@auth0/auth0-react";
import { useMemo } from "react";
import RemergeApi from "../http/RemergeApi";
import HttpService from "../services/HttpService";

export type UseAuth0RemergeApiParams = {
  apiHost: string;
};

/**
 * Shared API bootstrap for Auth0-backed apps.
 *
 * Security invariant: every API client created through this hook uses the same
 * Auth0 token getter contract for bearer-token fallback in HttpService.
 */
export function useAuth0RemergeApi({ apiHost }: UseAuth0RemergeApiParams): {
  httpService: HttpService;
  remergeApi: RemergeApi;
} {
  const { getAccessTokenSilently } = useAuth0();

  const httpService = useMemo(
    () => new HttpService(apiHost, getAccessTokenSilently),
    [apiHost, getAccessTokenSilently],
  );
  const remergeApi = useMemo(() => new RemergeApi(httpService), [httpService]);

  return {
    httpService,
    remergeApi,
  };
}
